import { formatOEENumber } from '@helpers';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { getOEEEffectivenessLabel } from '@components/machines/components/Utilization/components/chart/components/helpers';
import { UseManageUtilizationHeaderParams, UseManageUtilizationHeaderReturn } from '@components/machines/components/Utilization/components/chart/types';

export const useManageUtilizationHeader = ({
  machineStatistics,
  machineStatisticsLoading,
  machineStatisticsIsError,
}: UseManageUtilizationHeaderParams): UseManageUtilizationHeaderReturn => {
  const { timePeriod: selectedTime } = useHandleParams();

  const dataNotAvailable = machineStatisticsLoading || machineStatisticsIsError;
  const oee = dataNotAvailable ? null : formatOEENumber(machineStatistics.oee * 100);
  const teep = dataNotAvailable ? null : formatOEENumber(machineStatistics.teep * 100);
  const effectiveness = dataNotAvailable ? null : getOEEEffectivenessLabel(machineStatistics.oee);

  const oeeInt = String(oee || 0).split('.')[0];
  const oeeDec = String(oee).split('.')[1];
  const teepInt = String(teep || 0).split('.')[0];
  const teepDec = String(teep).split('.')[1];

  return {
    selectedTime,
    dataNotAvailable,
    oee,
    teep,
    oeeInt,
    oeeDec,
    teepInt,
    teepDec,
    effectiveness,
  };
};
